import { InputText, Text } from '@msc-b2c/shared-components';
import { validateFormField } from '@msc-b2c/shared-utils';
import { EmailInputSectionProps } from '@msc-b2c/interfaces/interfaces';
import styles from '../sidesummary.module.scss';

export function EmailInputSection({
  title,
  description,
  inputLabel,
  inputPlaceholder,
  inputRequiredLabel,
  validationRules,
  register,
  errors,
  clearErrors,
  onInputChange,
  onBlurTrigger,
}: Readonly<EmailInputSectionProps>) {
  return (
    <div className={styles['cmp-sidesummary__email-section']}>
      <div className={styles['cmp-sidesummary__email-text']}>
        {title && (
          <Text
            styleOption="h4"
            text={title}
          />
        )}
        {description && (
          <Text
            styleOption="cmp-text__big"
            text={description}
          />
        )}
      </div>
      {(inputLabel || inputPlaceholder) && (
        <div className={styles['cmp-sidesummary__email-input-wrapper']}>
          {inputRequiredLabel && (
            <Text
              styleOption={styles['cmp-sidesummary__email-required']}
              tagHtml="span"
              text={inputRequiredLabel}
            />
          )}
          <InputText
            styleOptions={styles['cmp-sidesummary__email-input']}
            index={0}
            name="emailOrderConfirmation"
            label={inputLabel || ''}
            placeholder={inputPlaceholder || ''}
            register={register}
            errors={errors}
            clearErrors={clearErrors}
            inputType="email"
            handleInputChange={onInputChange}
            validation={{
              validate: (value) => validateFormField(value, validationRules || []),
              onBlur: onBlurTrigger,
            }}
          />
        </div>
      )}
    </div>
  );
}
